import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from './Firebase';
//import { useIdleTimer } from 'react-idle-timer'; // Importa useIdleTimer

let userName = '';
let userEmail = '';// Variable para exportar

const UserProfile = ({ onPerfilChange }) => {
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const userProfileData = userSnap.data();
          setUserProfile(userProfileData);
          userName = `${userProfileData.nombre} ${userProfileData.apellido}`; // Actualiza la variable
          if (userProfileData.nombre === 'Marisa') {
            userEmail = 'sanchez_marisa@catainternacional.com';
          } else if (userProfileData.nombre === 'Dairelys') {
            userEmail = 'mendoza_dairelys@catainternacional.com';
          } else if (userProfileData.nombre === 'Giuliana') {
            userEmail = 'carmona_juliana@catainternacional.com';
          } else {
            userEmail = `${user.email}`;
          }
          onPerfilChange(userProfileData.perfil);
         // await updateDoc(userRef, { state: 'online' });
        }
      } else {
        setUserProfile(null);
        onPerfilChange(null);
      }
    });

    //pone al usuario en modo ofline cuando cierra la ventana
    
    /*window.addEventListener('beforeunload', async (e) => {
      const userRef = doc(db, 'users', auth.currentUser.uid);
      await updateDoc(userRef, { state: 'offline' });
    });*/

    return () => {
      unsubscribe();
    };
  }, [onPerfilChange]);

  /*const handleOnIdle = async () => {
    if (auth.currentUser) {
      const userRef = doc(db, 'users', auth.currentUser.uid);
      await updateDoc(userRef, { state: 'offline' });
    }
  };

  const handleOnActive = async () => {
    if (auth.currentUser) {
      setTimeout(async () => {
        const userRef = doc(db, 'users', auth.currentUser.uid);
        await updateDoc(userRef, { state: 'online' });
      }, 30000); // Espera 30 segundos antes de actualizar el estado a 'online'
    }
  };

  // Utiliza useIdleTimer
  useIdleTimer({
    timeout: 1000 * 60 * 5, // 5 minutos
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 250
  });*/

  if (!userProfile) {
    return <p>Cargando perfil...</p>;
  }

  return <p>{userProfile.nombre} {userProfile.apellido}</p>;
};

export { userName, userEmail };
export default UserProfile;